import { render, staticRenderFns } from "./relogin.vue?vue&type=template&id=780e608b&scoped=true&"
import script from "./relogin.vue?vue&type=script&lang=js&"
export * from "./relogin.vue?vue&type=script&lang=js&"
import style0 from "./relogin.vue?vue&type=style&index=0&id=780e608b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780e608b",
  null
  
)

export default component.exports